var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Nastavení druhů návštěv\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row between_rows justify-content-center"
  }, [(_vm.visit_purposes.length > 0 && !_vm.waitForResponse) ? _c('table', {
    staticClass: "table",
    attrs: {
      "data-testid": "settings-visit-purpose-list"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.visit_purposes), function(visit_purpose, index) {
    return _c('tr', {
      key: visit_purpose.id,
      attrs: {
        "data-testid": 'settings-visit-purpose-row-' + visit_purpose.id
      }
    }, [(_vm.edited_visit_purpose.id != visit_purpose.id) ? _c('td', {
      attrs: {
        "data-testid": 'settings-visit-purpose-name-' + visit_purpose.id
      }
    }, [_vm._v(_vm._s(visit_purpose.purpose))]) : _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.edited_visit_purpose.purpose),
        expression: "edited_visit_purpose.purpose"
      }],
      staticClass: "form-control mr-sm-2",
      attrs: {
        "type": "text",
        "aria-describedby": "purposeHelp",
        "id": "editPurpose",
        "data-testid": 'settings-visit-purpose-edit-name-' + visit_purpose.id
      },
      domProps: {
        "value": (_vm.edited_visit_purpose.purpose)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.edited_visit_purpose.purpose = $event.target.value
        }
      }
    })]), _vm._v(" "), (_vm.edited_visit_purpose.id != visit_purpose.id) ? _c('td', [_vm._v(_vm._s(visit_purpose.duration * _vm.minutes_per_window) + " minut")]) : _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.edited_visit_purpose.duration),
        expression: "edited_visit_purpose.duration"
      }],
      staticClass: "form-control mr-sm-2",
      attrs: {
        "id": "editDuration",
        "data-testid": 'settings-visit-purpose-edit-duration-' + visit_purpose.id
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.edited_visit_purpose.duration = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "",
        "disabled": "",
        "selected": ""
      }
    }, [_vm._v("zvolit čas")]), _vm._v(" "), _vm._l((24), function(duration) {
      return _c('option', {
        domProps: {
          "value": duration
        }
      }, [_vm._v(_vm._s(duration * 5) + " minut")])
    })], 2)]), _vm._v(" "), (visit_purpose.default == true) ? _c('td', {
      attrs: {
        "data-defualt": _vm.id_default = visit_purpose.id,
        "data-testid": 'settings-visit-purpose-default-' + visit_purpose.id
      }
    }, [_c('i', {
      staticClass: "fa fa-check-circle"
    })]) : _c('td', {
      attrs: {
        "data-testid": 'settings-visit-purpose-make-default-' + visit_purpose.id
      },
      on: {
        "mouseover": function($event) {
          _vm.id_hovered = visit_purpose.id
        },
        "mouseleave": function($event) {
          _vm.id_hovered = ''
        },
        "click": function($event) {
          _vm.changeDefaultTo(visit_purpose.id)
        }
      }
    }, [(_vm.id_hovered == visit_purpose.id) ? _c('i', {
      staticClass: "fa fa-check-circle-o"
    }) : _c('i', {
      staticClass: "fa fa-circle-o"
    })]), _vm._v(" "), (_vm.edited_visit_purpose.id != visit_purpose.id) ? _c('td', [_c('button', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "data-testid": 'settings-visit-purpose-edit-' + visit_purpose.id
      },
      on: {
        "click": function($event) {
          _vm.edited_visit_purpose = Object.assign({}, visit_purpose)
        }
      }
    }, [_vm._v("Upravit")])]) : _c('td', [_c('button', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "data-testid": 'settings-visit-purpose-save-' + visit_purpose.id
      },
      on: {
        "click": function($event) {
          _vm.putVisitPurpose()
        }
      }
    }, [_vm._v("Uložit")])])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.waitForResponse) ? _c('div', {}, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-block bg-light"
  }, [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.postVisitPurpose($event)
      }
    }
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "purpose"
    }
  }, [_vm._v("Důvod návštěvy")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit_purpose.purpose),
      expression: "visit_purpose.purpose"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "type": "text",
      "aria-describedby": "purposeHelp",
      "id": "purpose",
      "data-testid": "settings-visit-purpose-new-name"
    },
    domProps: {
      "value": (_vm.visit_purpose.purpose)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.visit_purpose.purpose = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "purposeHelp"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "duration"
    }
  }, [_vm._v("Délka návštěvy:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit_purpose.duration),
      expression: "visit_purpose.duration"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "id": "duration",
      "data-testid": "settings-visit-purpose-new-duration"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit_purpose.duration = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit čas")]), _vm._v(" "), _vm._l((24), function(duration) {
    return _c('option', {
      domProps: {
        "value": duration
      }
    }, [_vm._v(_vm._s(duration * 5) + " minut")])
  })], 2), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "settings-visit-purpose-add"
    }
  }, [_vm._v("Přidat druh návštěvy")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Důvod návštěvy")]), _vm._v(" "), _c('th', [_vm._v("Délka návštěvy")]), _vm._v(" "), _c('th', [_vm._v("Výchozí")]), _vm._v(" "), _c('th')])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-265195e3","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Setting/components/VisitPurposes.vue
// module id = 606
// module chunks = 0